<template>
  <div class="handle-area">
    <div class="handle-item" v-if="querybtn.note_allocate === 1">
      <span>设置留言自动分配给：</span>
      <el-select v-model="autoCustomerId" placeholder="请选择客服" size="mini" @change="handleChange" v-loading="isLoading">
        <el-option label="不分配" value=""></el-option>
        <el-option :label="item.customerName" :value="item.userId" v-for="(item, index) in customerList" :key="index"></el-option>
      </el-select>
    </div>
    <div class="handle-item" v-if="codeUrl">
      <span>关注伊课服务号接收用户留言提醒：</span>
      <el-popover
        placement="bottom"
        width="200"
        trigger="hover">
        <img :src="codeUrl" alt="" style="max-width: 100%">
        <i class="iconfont icon-erweima cursor" slot="reference" style="font-size: 20px;font-weight: 500"></i>
      </el-popover>
    </div>
  </div>
</template>

<script>
import {queryAutoMessagePolicy, setAutoMessagePolicy, queryQRCodeWithParames} from '../../api/message'
import {queryCustomerList} from '../../api/statistics/index'
export default {
  props: {
    querybtn: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    querybtn: {
      handler () {
        // 有分配权限
        if (this.querybtn.note_allocate === 1) {
          this.getCustomerList()
        }
      },
      deep: true
    }
  },
  data () {
    return {
      codeUrl: '',
      isLoading: false,
      customerList: [],
      oldAutoCustomerId: '',
      // 自动分配的客服id
      autoCustomerId: ''
    }
  },
  computed: {
    currentCustomerName () {
      const customerItem = this.customerList.find(item => item.userId === this.autoCustomerId)
      return customerItem ? customerItem.customerName : ''
    }
  },
  created () {
    this.initCode()
  },
  methods: {
    // 获取二维码
    initCode () {
      queryQRCodeWithParames().then(res => {
        if (res.data.resultCode === 0) {
          this.codeUrl = res.data.resultData.qrcodeUrl
        }
      })
    },
    getCustomerList () {
      this.isLoading = true
      queryCustomerList().then(res => {
        if (res.data.resultCode === 0) {
          this.customerList = res.data.resultData
          this.getAutoMessagePolicyInfo()
        } else {
          this.$message.error(res.data.resultMessage)
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    // 选择客服
    handleChange (val) {
      let title = this.currentCustomerName ? `确定将后续的用户留言自动分配给【${this.currentCustomerName}】吗？` : '后续留言将不自动分配'
      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.oldAutoCustomerId = this.autoCustomerId
        let params = {
          customerId: this.autoCustomerId
        }
        setAutoMessagePolicy(params).then((res) => {
          if (res.data.resultCode === 0) {
            this.$message({
              message: '设置成功',
              type: 'success'
            })
            this.getAutoMessagePolicyInfo()
          } else {
            this.$message.error(res.data.resultMessage)
          }
        })
      }).catch(() => {
        // 取消 恢复到之前的状态
        this.autoCustomerId = this.oldAutoCustomerId
      })
    },
    getAutoMessagePolicyInfo () {
      queryAutoMessagePolicy().then((res) => {
        if (res.data.resultCode === 0) {
          this.autoCustomerId = res.data.resultData.customerId || ''
          this.oldAutoCustomerId = this.autoCustomerId
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.handle-area{
  display: flex;
  gap: 20px;
  color: #666;
  margin-bottom: 10px;
  .handle-item{
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Message/HandleArea.vue